import {
  BoosterAdvancedSettingsAction,
  LOAD_BOOSTER_ADVANCED_SETTINGS, LOAD_BOOSTER_ADVANCED_SETTINGS_FAIL,
  LOAD_BOOSTER_ADVANCED_SETTINGS_SUCCESS,
  LoadBoosterAdvancedSettings, LoadBoosterAdvancedSettingsFail,
  LoadBoosterAdvancedSettingsSuccess
} from "../actions";

export interface IBoosterAdvancedSettingsEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IBoosterAdvancedSettingsState {
  entities: {[websiteId: number]: IBoosterAdvancedSettingsEntityState};
}

export const initialState: IBoosterAdvancedSettingsState = {
  entities: {}
};

export function reducer(state: IBoosterAdvancedSettingsState = initialState, action: BoosterAdvancedSettingsAction): IBoosterAdvancedSettingsState {
  let payload: any;

  switch (action.type) {

    case LOAD_BOOSTER_ADVANCED_SETTINGS:
      payload = (<LoadBoosterAdvancedSettings>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BOOSTER_ADVANCED_SETTINGS_SUCCESS:
      payload = (<LoadBoosterAdvancedSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_ADVANCED_SETTINGS_FAIL:
      payload = (<LoadBoosterAdvancedSettingsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
